import { Button, Chip, IconButton, ListSubheader, Stack, Tooltip, Typography } from '@mui/material'
import React, { forwardRef } from 'react'

interface ButtonConfig {
    label?: string
    icon?: React.ReactNode
    action?: (any) => void
    tooltip?: string
}
interface P {
    title?: string
    icons?: string
    label?: string
    buttons?: ButtonConfig[]
    children: any
    chipLabel?: string
}

const renderButtons = (buttons: ButtonConfig[]) => {
    if (!buttons) return null
    return (
        <Stack direction='row' justifyContent='end'>
            {
                buttons.map((button, i) => (
                    <React.Fragment key={i}>
                        {button.icon
                            ? (
                                    <Tooltip arrow title={button.tooltip ?? ''}>
                                        <IconButton onClick={button?.action}>
                                            {button.icon && (
                                                button.icon
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                )
                            : (
                                    <Tooltip arrow title={button.tooltip ?? ''}>
                                        <Button onClick={button?.action}>
                                            {button.label}
                                        </Button>
                                    </Tooltip>
                                )}
                    </React.Fragment>
                ))
            }
        </Stack>
    )
}

const LabeledChart = forwardRef<HTMLDivElement, P>(function LabeledChart({ title, label, buttons, children, chipLabel }: P, ref) {
    return (
        <Stack sx={{ minHeight: 360, height: '100%' }} ref={ref}>

            {title && (
                <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                    <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                        {
                            chipLabel && (
                                <Chip size='small' variant='outlined' label={chipLabel} />
                            )
                        }
                        <Typography variant='subtitle1' fontWeight='600'>{title}</Typography>
                    </Stack>
                    { (buttons && buttons.length > 0) ? (renderButtons(buttons)) : 'No buttons' }
                </Stack>
            )}

            {label && (
                <ListSubheader>{label}</ListSubheader>
            )}

            <Stack sx={{ height: '100%', paddingBottom: '36px', width: '100%', flexGrow: 1 }}>
                {children}
            </Stack>
        </Stack>
    )
})

export default LabeledChart
